<template>
    <div class="softphone" id="softphone">
        <table class="phonestatus">
            <tr>
                <td>分机号：{{extno}}</td>
                <td>状态：{{globalStatus.tips}}</td>
                <td>当前排队量：{{waitnum}}</td>
                <td>当前接听量：{{answernum}}</td>
                <td>
                    <el-badge :is-dot="!!extErr.length" class="item">
                        <el-dropdown trigger="click" :hide-on-click="false">
                            <span class="el-dropdown-link">
                                <el-link class="softphone-link">异常记录</el-link>
                            </span>
                            <el-dropdown-menu class="softphone-dropdown" slot="dropdown">
                                <el-dropdown-item v-if="!extErr.length">暂无异常</el-dropdown-item>
                                <el-dropdown-item else v-for="(item,index) in extErr" :key="index">{{item}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </el-badge>
                    <div class="light" :style="{backgroundColor: statusColor}"></div>
                </td>
            </tr>
        </table>
        <table class="operation">
            <tr>
                <td>
                    <el-button type="primary" size="mini" :loading="loadingLogin" @click="login(globalStatus.text.login)" :disabled="globalStatus.button.login">{{globalStatus.text.login}}</el-button>
                </td>
                <td>
                    <el-button type="primary" size="mini" :loading="loadingReady" @click="ready(globalStatus.text.ready)" :disabled="globalStatus.button.ready">{{globalStatus.text.ready}}</el-button>
                </td>
                <td>
                    <el-button type="primary" size="mini" :loading="loadingHold" @click="hold(globalStatus.text.hold)" :disabled="globalStatus.button.hold">{{globalStatus.text.hold}}</el-button>
                </td>
                <td>
                    <el-button type="primary" size="mini" :loading="loadingSurvey" @click="survey" :disabled="globalStatus.button.survey">{{globalStatus.text.survey}}</el-button>
                </td>
                <td>
                    <el-button type="primary" size="mini" :loading="loadingHungup" @click="hungup" :disabled="globalStatus.button.hungup">{{globalStatus.text.hungup}}</el-button>
                </td>
            </tr>
        </table>
    </div>
</template>
<script>
/* eslint-disable */

import { getAppEnv } from "@public/utils/common";
const portMap = {
    local: "9060", // 本地
    test: "9060",
    dev: "9060",
    uat: "9060",
    pro: "9060",
};

const fsMap = {
    local: "180.167.255.223", // 本地
    test: "180.167.255.223",
    dev: "180.167.255.223",
    uat: "180.167.255.220",
    pro: "180.167.255.220",
};

const hostMap = {
    local: "call.jtexpress.com.cn", // 本地
    test: "call.jtexpress.com.cn",
    dev: "call.jtexpress.com.cn",
    uat: "call2.jtexpress.com.cn",
    pro: "call2.jtexpress.com.cn",
};
const TIMEOUT = 10000;
export default {
    name: "Softphone",
    props: ["extno", "queue"],
    data() {
        return {
            trackingnumber: "",
            phone: "",
            currenPhone: "",
            softPhoneStatus: 1,
            waitnum: "0",
            answernum: "0",
            websocket: {},
            agentid: "",
            AgentStatus: "",
            Ring_ID: "",
            Call_ID: "",
            extErr: [], //分机异常记录
            statusColor: "red",
            loadingLogin: false,
            loadingReady: false,
            loadingHold: false,
            loadingSurvey: false,
            loadingHungup: false,
            uuidObj:{}
        };
    },
    mounted() {
        window.testFn = this.sessionEvent;
        document.getElementById("softphone").addEventListener("keydown", evt => {
            if (['Enter','Space','NumpadEnter'].includes(evt.code)) {
                if (evt.preventDefault) {
                    evt.preventDefault();
                }
            }
        });
    },
    watch: {
        trackingnumber(a) {
            if (a != "") {
                this.$emit("changeWaybill", a);
            }
            this.trackingnumber = "";
        },
        phone(a) {
            if (a != "") {
                this.$emit("changePhone", a);
            }
            this.phone = "";
        },
    },
    destroyed: function () {
        if (this.websocket.readyState == 1) {
            this.websocket.onclose = null;
            // this.websocket.send("LogOut|" + this.agentid);
            this.websocket.close();
        }
    },
    methods: {
        error(message) {
            this.$message.error(message);
        },
        verify(success, fail) {
            return new Promise((reslove) => {
                let verify = ({ data }) => {
                    if (success && data.includes(success)) {
                        this.websocket.removeEventListener("message", verify);
                        reslove(true);
                    }
                    if (fail && data.includes(fail)) {
                        this.websocket.removeEventListener("message", verify);
                        reslove(false);
                    }
                };
                this.websocket.addEventListener("message", verify);
                setTimeout(() => {
                    this.websocket.removeEventListener("message", verify);
                    reslove(false);
                }, TIMEOUT);
            });
        },
        setready() {
            // 保存录单页面后，调用此方法，电话条重新就绪
            if (this.websocket.readyState == 1 && this.softPhoneStatus == 7) {
                this.setStatus(0);
            }
        },
        login(text) {
            this.loadingLogin = true;
            let timer = setTimeout(() => {
                this.loadingLogin = false;
            }, TIMEOUT);
            if (text == "登陆") {
                if (this.websocket.readyState == 1) {
                    this.websocket.close();
                }
                const prefix = "wss://";
                // location.protocol === "http:" ? "ws://" : "wss://";
                this.agentid = this.extno + "@" + this.fs;
                this.websocket = new WebSocket(
                    prefix + this.host + ":" + this.port + "/"
                );
                this.websocket.addEventListener("open", () => {
                    this.statusColor = "chartreuse";
                });
                this.websocket.addEventListener("close", () => {
                    this.softPhoneStatus = 1;
                    this.statusColor = "red";
                });
                this.websocket.onopen = () => {
                    //LoginSuccess|20009|<eof>
                    //LoginFailed|20009|<eof>
                    this.verify(
                        "LoginSuccess|" + this.extno + "|<eof>",
                        "LoginFailed|" + this.extno + "|<eof>"
                    ).then((res) => {
                        if (res) {
                            clearTimeout(timer);
                            this.setStatus(11).finally(() => {
                                this.loadingLogin = false;
                            });
                        } else {
                            this.error("登陆失败,检查分机是否注册,请稍后重试");
                            this.websocket.onclose = null;
                            // this.websocket.send("LogOut|" + this.agentid);
                            this.websocket.close();
                            clearTimeout(timer);
                            this.loadingLogin = false;
                        }
                    });
                    this.websocket.send(
                        "Login|" +
                            this.agentid +
                            "|" +
                            this.extno +
                            "|" +
                            this.queue
                    );
                };
                this.websocket.onclose = () => {
                    this.loadingLogin = false;
                    clearTimeout(timer);
                    this.error("重复登录或服务器连接断开");
                };
                this.websocket.onmessage = this.onmessage;
            } else {
                this.websocket.onclose = () => {
                    this.loadingLogin = false;
                    clearTimeout(timer);
                };
                // this.websocket.send("LogOut|" + this.agentid);
                this.websocket.close();
            }
        },
        ready(text) {
            this.loadingReady = true;
            let timer = setTimeout(() => {
                this.loadingReady = false;
            }, TIMEOUT);
            if (text == "未就绪") {
                this.setStatus(0).then(() => {
                    this.loadingReady = false;
                    clearTimeout(timer);
                });
            } else if (text == "就绪") {
                this.setStatus(1).then(() => {
                    this.loadingReady = false;
                    clearTimeout(timer);
                });
            }
        },
        hold(text) {
            this.loadingHold = true;
            let timer = setTimeout(() => {
                this.loadingHold = false;
            }, TIMEOUT);
            if (text == "保持") {
                //HoldEvent|20009|0ff6b2e6-5c11-11ec-92a4-dfad6754e0ca|<eof>
                this.verify(
                    "HoldEvent|" + this.extno + "|" + this.Ring_ID + "|<eof>"
                ).then((res) => {
                    if (res) {
                        this.softPhoneStatus = 6;
                    }
                    this.loadingHold = false;
                    clearTimeout(timer);
                });
                this.websocket.send("Hold|" + this.Ring_ID);
            } else {
                //UnholdEvent|20009|0ff6b2e6-5c11-11ec-92a4-dfad6754e0ca|<eof>
                this.verify(
                    "UnholdEvent|" + this.extno + "|" + this.Ring_ID + "|<eof>"
                ).then((res) => {
                    if (res) {
                        this.softPhoneStatus = 5;
                    }
                    this.loadingHold = false;
                    clearTimeout(timer);
                });
                this.websocket.send("UnHold|" + this.Ring_ID);
            }
        },
        survey() {
            this.loadingSurvey = true;
            let timer = setTimeout(() => {
                this.loadingSurvey = false;
            }, TIMEOUT);
            //HangupEvent|20009|0ff6b2e6-5c11-11ec-92a4-dfad6754e0ca|15107241502|<eof>
            this.verify(
                "HangupEvent|" +
                    this.extno +
                    "|" +
                    this.Ring_ID +
                    "|" +
                    this.currenPhone +
                    "|<eof>"
            ).then(() => {
                this.loadingSurvey = false;
                clearTimeout(timer);
            });
            this.websocket.send(
                "Survey|" +
                    this.Ring_ID +
                    "|" +
                    this.queue +
                    "|" +
                    this.Call_ID +
                    "|" +
                    this.currenPhone
            );
        }, // 转接
        hungup() {
            this.loadingHungup = true;
            let timer = setTimeout(() => {
                this.loadingHungup = false;
            }, TIMEOUT);
            //HangupEvent|20009|cabc1d96-5c11-11ec-a039-dfad6754e0ca|15107241502|<eof>
            this.verify(
                "HangupEvent|" +
                    this.extno +
                    "|" +
                    this.Call_ID +
                    "|" +
                    this.currenPhone +
                    "|<eof>"
            ).then(() => {
                this.loadingHungup = false;
                clearTimeout(timer);
            });
            this.websocket.send("Hangup|" + this.Ring_ID + "|" + this.Call_ID);
        },
        setStatus(status) {
            return new Promise((reslove) => {
                this.verify(
                    "AgentStatus|" +
                        this.agentid +
                        "|" +
                        this.extno +
                        "|" +
                        status +
                        "|<eof>"
                ).then((res) => {
                    reslove(res);
                });
                this.websocket.send(
                    "SetStatus|" +
                        this.agentid +
                        "|" +
                        this.extno +
                        "|" +
                        status
                );
            });
        },
        onmessage(event) {
            this.sessionEvent(event.data);
        },
        sessionEvent(data) {
            let str = new Array();
            str = data.split("|");
            const EventName = str[0];
            switch (EventName) {
                case "ERROR":
                    //记录错误信息
                    let extErr = this.getCurrentDateHMS() + " " + str[1];
                    this.extErr.unshift(extErr);
                    if (this.extErr.length > 5) {
                        this.extErr.splice(0, this.extErr.length - 5);
                    }
                    localStorage.setItem(
                        "softphoneErr",
                        this.extErr.join("||")
                    );
                    let errorList = ["USER_NOT_REGISTERED"];
                    if (errorList.some((s) => extErr.includes(s))) {
                        this.websocket.onclose = null;
                        this.websocket.close();
                    }
                    break;
                case "PhoneUnreg":
                    this.error("分机未注册,请重新登陆");
                    this.websocket.onclose = null;
                    this.websocket.close();
                    break;
                case "RingingEvent": //
                    //RingingEvent|20009|15107241502|20009|15107241502|0ff6b2e6-5c11-11ec-92a4-dfad6754e0ca||<eof>
                    this.Ring_ID = str[5];
                    break;
                case "CallTalkingEvent": // 分机应答
                    //CallTalkingEvent|20009|15107241502|888888@180.167.255.220||mod_callcenter|e9c2cd4e-5c10-11ec-8f5e-dfad6754e0ca|e9c2cd4e-5c10-11ec-8f5e-dfad6754e0ca|inbound||<eof>
                    this.softPhoneStatus = 5;
                    this.Call_ID = str[6];
                    this.trackingnumber = str[4];
                    this.phone = str[2];
                    this.currenPhone = str[2];
                    this.uuidObj = {uuid: this.Call_ID, phone:this.phone};
                    localStorage.setItem('uuidObj', JSON.stringify(this.uuidObj));
                    break;
                case "MembersCountEvent":
                    this.waitnum = str[3];
                    break;
                case "Answernum":
                    this.answernum = str[3];
                    break;
                case "HangupEvent": // 分机挂机
                    if (this.Ring_ID == str[2]) {
                        this.$emit("talkEnd");
                        this.softPhoneStatus = 7;
                        // this.phone = "";
                        // this.currenPhone = "";
                        setTimeout(() => {
                            this.softPhoneStatus == 7 && this.setStatus(0);
                        }, 5000);
                    }
                    break;
                case "AgentStatus":
                    if (![5, 6].includes(this.softPhoneStatus)) {
                        this.AgentStatus = str[3];
                        switch (this.AgentStatus) {
                            case "0":
                                this.softPhoneStatus = 4;
                                break;
                            case "1":
                                this.softPhoneStatus = 3;
                                break;
                            case "2":
                                this.softPhoneStatus = 7;
                                setTimeout(() => {
                                    this.softPhoneStatus == 7 &&
                                        this.setStatus(0);
                                }, 5000);
                                break;
                            case "11":
                                this.softPhoneStatus = 2;
                                break;
                            default:
                                break;
                        }
                        break;
                    }
            }
        },
        getCurrentDateHMS() {
            let time = new Date();
            var H = time.getHours();
            H = H < 10 ? "0" + H : H;
            var Mi = time.getMinutes();
            Mi = Mi < 10 ? "0" + Mi : Mi;
            var S = time.getSeconds();
            S = S < 10 ? "0" + S : S;
            return H + ":" + Mi;
        },
    },
    created() {
        this.host = hostMap["pro"];
        this.port = portMap["pro"];
        this.fs = fsMap["pro"];

        let time = new Date();
        let saveTime = localStorage.getItem("softphoneErrDate");
        let nowTime = time.getMonth() + " " + time.getDate();
        if (saveTime === nowTime) {
            let extErrStr = localStorage.getItem("softphoneErr") || "";
            if (extErrStr) {
                this.extErr = extErrStr.split("||");
            } else {
                this.extErr = [];
            }
        } else {
            localStorage.setItem("softphoneErrDate", nowTime);
            localStorage.removeItem("softphoneErr");
        }
    },
    computed: {
        globalStatus: function () {
            let objec = {
                text: {},
                button: {},
                tips: {},
            };
            //1未登录
            //2已登陆
            //3未就绪
            //4已就绪
            //5通话中
            //6保持中
            //7话后中
            switch (this.softPhoneStatus) {
                case 1:
                    objec = {
                        text: {
                            login: "登陆",
                            ready: "未就绪",
                            hold: "保持",
                            survey: "邀评",
                            hungup: "挂断",
                        },
                        button: {
                            login: false,
                            ready: true,
                            hold: true,
                            survey: true,
                            hungup: true,
                        },
                        tips: "未登录",
                    };
                    break;
                case 2:
                    objec = {
                        text: {
                            login: "登出",
                            ready: "未就绪",
                            hold: "保持",
                            survey: "邀评",
                            hungup: "挂断",
                        },
                        button: {
                            login: false,
                            ready: false,
                            hold: true,
                            survey: true,
                            hungup: true,
                        },
                        tips: "已登陆",
                    };
                    break;
                case 3:
                    objec = {
                        text: {
                            login: "登出",
                            ready: "未就绪",
                            hold: "保持",
                            survey: "邀评",
                            hungup: "挂断",
                        },
                        button: {
                            login: false,
                            ready: false,
                            hold: true,
                            survey: true,
                            hungup: true,
                        },
                        tips: "未就绪",
                    };
                    break;
                case 4:
                    objec = {
                        text: {
                            login: "登出",
                            ready: "就绪",
                            hold: "保持",
                            survey: "邀评",
                            hungup: "挂断",
                        },
                        button: {
                            login: false,
                            ready: false,
                            hold: true,
                            survey: true,
                            hungup: true,
                        },
                        tips: "就绪中",
                    };
                    break;
                case 5:
                    objec = {
                        text: {
                            login: "登出",
                            ready: "就绪",
                            hold: "保持",
                            survey: "邀评",
                            hungup: "挂断",
                        },
                        button: {
                            login: true,
                            ready: true,
                            hold: false,
                            survey: false,
                            hungup: false,
                        },
                        tips: "通话中",
                    };
                    break;
                case 6:
                    objec = {
                        text: {
                            login: "登出",
                            ready: "就绪",
                            hold: "取回",
                            survey: "邀评",
                            hungup: "挂断",
                        },
                        button: {
                            login: true,
                            ready: true,
                            hold: false,
                            survey: true,
                            hungup: true,
                        },
                        tips: "保持中",
                    };
                    break;
                case 7:
                    objec = {
                        text: {
                            login: "登出",
                            ready: "就绪",
                            hold: "保持",
                            survey: "邀评",
                            hungup: "挂断",
                        },
                        button: {
                            login: false,
                            ready: false,
                            hold: true,
                            survey: true,
                            hungup: true,
                        },
                        tips: "处理中",
                    };
                    break;
            }
            return objec;
        },
    },
};
</script>
<style lang="scss">
.softphone {
    .el-button.el-button--primary.is-disabled {
        background-color: rgba(255, 255, 255, 0.3);
        border-color: rgba(255, 255, 255, 0.3);
        span {
            color: #fff !important;
        }
    }
    .el-button.el-button--primary {
        background-color: #fff;
        border-color: #fff;
        border: 0;
        padding-top: 8px;
        padding-bottom: 8px;
        span {
            @include base-color("clr");
        }

        &:focus,
        &:link,
        &:active,
        &:visited {
            background-color: #fff;
            border-color: #fff;
        }
        &:hover {
            background-color: rgba(255, 255, 255, 0.6);
            border-color: rgba(255, 255, 255, 0.6);
        }
    }
}
</style>
<style lang="scss">
.softphone {
    width: 100%;
    height: 70px;
    @include base-color("bg");
    border-radius: 8px;
    border: 1px solid rgba(221, 221, 221, 1);
    @include border-color("brand");
}
.softphone .phonestatus {
    margin-top: 5px;
    margin-bottom: 5px;
    text-align: left;
    width: 100%;
    font-size: 12px;
    // font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #fff;
}
.softphone .phonestatus td {
    width: 20%;
}
.softphone .operation {
    text-align: left;
    width: 100%;
    margin-top: 5px;
    margin-bottom: 5px;
}
.softphone .operation td {
    width: 20%;
}
.softphone .phonestatus .light {
    border-radius: 50%;
    width: 11px;
    background-color: red;
    height: 11px;
    display: inline-block;
    vertical-align: middle;
    margin-left: 10px;
}
.softphone .el-icon-loading {
    color: #f5901f;
}
.softphone-dropdown {
    max-height: 300px;
    overflow: overlay;
    font-size: 12px !important;
    font-weight: 400 !important;
}
.softphone-dropdown .el-dropdown-menu__item {
    font-size: 12px !important;
    font-weight: 400 !important;
}
.softphone-link {
    color: white !important;
    font-size: 12px !important;
    font-weight: 400 !important;
}
</style>
